import MyDrawer from "components/NotificationsSidebar/components/MyDrawer/MyDrawer";

import {useNIA} from "./NIAContext";
import NIAWorkspace from "./NIAWorkspace";

const NIADrawer = () => {
  const {closeDrawer, isDrawerOpen} = useNIA();

  return (
    <MyDrawer open={isDrawerOpen} handleClose={closeDrawer}>
      <NIAWorkspace mode="drawer" />
    </MyDrawer>
  );
};

export default NIADrawer;
